import $ from 'jquery';
$(document).ready(function () {
    if ($('#blog_page').length) {
        var form = document.getElementById("searchForm");
        var form1 = document.getElementById("searchForm1");
        var pageNumber = 1;

        $("#searchForm").submit(function (e) {
            e.preventDefault();
        });

        $("#lnkSearch").click(function () {
            getSearch();
        });

        $("#lnkSearch1").click(function () {
            getSearch1();
        });

        $("#searchText").on("keydown", (e) => {
            if (e.keyCode == 13) {
                getSearch();
            }
        });

        $("#searchText1").on("keydown", (e) => {
            if (e.keyCode == 13) {
                getSearch1();
            }
        });

        if ($(".blogs").prop("scrollHeight") > 2000) {
            //$(".blogs").height("2000");
            $(".blogs").height("auto");
            $('.show-more').css('display', 'block');
        }
        else {
            $(".blogs").height("auto");
            $('.show-more').css('display', 'none');
        }


        $("#lnkSearch1").click(function () {
            getSearch1();
        });


        function getSearch() {
            var link = $("#searchForm").attr("action");
            var searchText = $("#searchText").val();
            link = link + '&searchText=' + encodeURI(searchText);
            window.location.href = link;
        }

        function getSearch1() {
            var link = $("#searchForm1").attr("action");
            var searchText = $("#searchText1").val();
            link = link + '&searchText=' + encodeURI(searchText);
            window.location.href = link;
        }

        $("#btnShowMore").click(function () {
            var link = $("#btnShowMore").attr("action");
            link = link + '&pageNumber=' + pageNumber;
            $.ajax({
                url: link,
                success: function (data) {
                    $("#blogs").append(data);
                    pageNumber++;
                }
            })
        })
    }
});
